import React from "react";
import Card from "@material-ui/core/Card";
import GraphDataCardMobile from "./GraphDataCardMobile";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import "./GraphDataCards.scss";

const useStyles = makeStyles({
  root: {
    background: "rgba(67, 71, 91, 0.25)",
    width: "130px"
  }
});

const GraphDataCardPaneMobile = ({ graphName, spotter }) => {
  const classes = useStyles();

  const obsGraphStore = {
    significantWaveHeight: "wave height",
    peakPeriod: "peak period",
    meanPeriod: "mean period",
    peakDirection: "peak direction",
    meanDirection: "mean direction",
    peakDirectionalSpread: "peak spread",
    meanDirectionalSpread: "mean spread"
  };

  const modelGraphStore = {
    significantWaveHeight: "wave height",
    waveHeight: "wave height",
    peakPeriod: "peak mean period",
    period: "mean mean period",
    meanPeriod: "mean mean period",
    peakDirection: "peak mean direction",
    meanDirection: "mean mean direction",
    peakDirectionalSpread: "peak mean spread",
    spread: "mean mean spread",
    meanDirectionalSpread: "mean mean spread"
  };

  return (
    <div
      id="graph-data-card-pane-mobile"
      className="graph-data-card-pane-mobile"
    >
      <Grid container spacing={2}>
        {spotter && (
          <Grid key={graphName} item>
            <Card className={classes.root}>
              <GraphDataCardMobile
                color="rgba(227,199,52,1)"
                data="-"
                dataType={`${obsGraphStore[graphName]} observations`}
              />
            </Card>
          </Grid>
        )}
        <Grid item>
          <Card className={classes.root}>
            <GraphDataCardMobile
              color="rgba(183,76,164,1)"
              data="-"
              dataType={`${modelGraphStore[graphName]} model`}
            />
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default GraphDataCardPaneMobile;
